;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
const NO_TITLE = "No group title added"

export default function GroupTitle({ group }) {
  const name = group?.name || NO_TITLE
  return (
    <h1
      className={`font-bebas tracking-[.035em] text-center text-[28px] leading-[33px] min-[600px]:leading-[43px] min-[600px]:text-[36px] m-0 ${NO_TITLE == name ? "text-red-accent" : ""}`}
    >
      {name}
    </h1>
  )
}
